import { useCallback } from 'react'
import { useReactFlow } from '@xyflow/react'

/**
 * Returns a `patch` function that updates `node.data` for the given node ID.
 * The patch is merged into existing data, then propagated through React Flow's
 * store — making it the single source of truth that `toSchemaTree` reads on save.
 *
 * Usage inside a custom node component:
 *
 *   const patchData = useNodeData(id)
 *   patchData({ selectedId: '3' })  // → node.data.selectedId = '3'
 */
export function useNodeData(id: string) {
  const { setNodes } = useReactFlow()
  return useCallback(
    (patch: Record<string, any>) => {
      setNodes(nodes =>
        nodes.map(n =>
          n.id === id ? { ...n, data: { ...n.data, ...patch } } : n
        )
      )
    },
    [id, setNodes]
  )
}
